module.exports = __webpack_public_path__ + "static/ip-ikon7-c2bfcbf50ce0cc648e8a17759073a70f.png";